import styled from 'styled-components'

export const Display = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;

  div.display {
    display: flex;
    flex-direction: row;

    div {
      flex: 1;
      margin: 0;
    }

    div + div {
      margin-left: 5px;
    }
  }

  .btn_message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  div.ui.message + div.ui.message {
    margin-left: 4px;
  }

  div.ui.message {
    margin-top: 0px;
    margin-bottom: 5px;
  }

  div.script_atendimento {
    textarea {
      background-color: #dff0ff;

      &&:active {
        background-color: #dff0ff;
      }
    }
  }

  .fields_personalizados {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;

    div.field {
      width: 25%;
    }
  }
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .form_chamado {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  div.btn_area {
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 5px;
  }

  div.ui.compact.menu div.menu.transition.visible div.item {
    /* background-color: red !important; */
    padding: 0px !important;
    margin: 0 !important;
    display: flex
  }
  div.ui.compact.menu div.menu.transition.visible div.item div.ui.dropdown {
    padding: 10px;
    flex: 1;
  }
  div.ui.active.visible.dropdown div.menu.transition.visible div.item.final_item {
    padding: 10px !important;
  }
`
